export default __webpack_public_path__ + "static/media/reward.3a032f81.svg";